
import { Component, Vue, Watch } from 'vue-property-decorator'
import { delObjEmptyKey } from '@/utils'
import { dateToSeconds, pickerOptions, getCurrentDate } from '@/utils/dateTime'
import { getRequestLog, readRequestLog } from '@/api/order/index'
import logDetails from './components/logDetails.vue'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'requestLog',
  components: {
    logDetails
  }
})
export default class extends Vue {
  queryForm: any = {
    merchant_no: null,
    notify_ordernumber: null,
    start_time: null,
    end_time: null,
    min_amount: null,
    max_amount: null
  }
  private date: any[] = getCurrentDate()
  private total = 0
  private listLoading: Boolean = false
  private dialogVisible: boolean = false
  private pickerOptions = pickerOptions
  private list: any[] = []
  private drawer: boolean = false
  private logDetails: any = {}

  private openDrawer(row: number) {
    this.logDetails = row
    this.drawer = true
  }
  private closeDrawer(isManual: boolean = false) {
    if (isManual) {
      this.drawer = false
    }
    this.hadleGetFilesListApi()
  }

  // 创建时间监听
  @Watch('date', { immediate: true })
  private pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    }
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data: any = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      delObjEmptyKey(data)
      await getRequestLog(data).then((res: any) => {
        this.list = res.results
        this.total = res.count
        this.listLoading = false
      })
    } catch (error) {
      this.listLoading = false
    }
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }
  private reset() {
    this.queryForm = {
      merchant_no: null,
      notify_ordernumber: null,
      start_time: null,
      end_time: null,
      min_amount: null,
      max_amount: null
    }
    this.date = getCurrentDate()
    this.currentPage = 1
    this.$nextTick(() => {
      // this.getloginLog(true)
      this.hadleGetFilesListApi()
    })
  }

  private async clearCount() {
    await readRequestLog({ status: 1 }).then(() => {})
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    this.clearCount()
    this.hadleGetFilesListApi()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.requestLog`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
